import { Fragment, useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITourStep from 'ui-shepherd-react/tour/UITourStep';
import UITourBackButton from 'ui-shepherd-react/button/UITourBackButton';
import UITourNextButton from 'ui-shepherd-react/button/UITourNextButton';
import { H4 } from 'UIComponents/elements/headings';
import TourStepCount from 'ContentEditorUI/components/shared/TourStepCount';
// @ts-expect-error Untyped module.
import { trackInpageUsageEvent } from '../../eventsAsActions/layoutTransitionEventsAsActions';
// @ts-expect-error Untyped module.
import { useBus } from '../../context/Bus';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const BlogPlgOnboardingUITourStepPostBody = () => {
  const bus = useBus();
  const onBeforeNextStep = useCallback(({
    stepKey
  }) => {
    bus.dispatchActionToEventBus(trackInpageUsageEvent({
      action: 'Blog Onboarding',
      event: 'completed-onboarding-tour-step',
      subscreen: stepKey
    }));
  }, [bus]);
  const tourKey = 'BLOG_PLG_ONBOARDING';
  return /*#__PURE__*/_jsx(UITourStep, {
    stepKey: "postBody",
    tourKey: tourKey,
    showCloseButton: true,
    attachTo: "#hs_cos_wrapper_post_body",
    width: 420,
    content: {
      header: /*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "plgOnboardingTour.step.postBody.header"
        })
      }),
      body: /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx(TourStepCount, {
          tourKey: tourKey
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "plgOnboardingTour.step.postBody.body"
          })
        })]
      }),
      footer: /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx(UITourBackButton, {}), /*#__PURE__*/_jsx(UITourNextButton, {
          beforeNext: onBeforeNextStep,
          use: "primary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "plgOnboardingTour.step.postBody.button.next"
          })
        })]
      })
    },
    pulser: {
      attachTo: '#hs_cos_wrapper_post_body'
    }
  });
};